// extracted by mini-css-extract-plugin
var _1 = "Divider_dark__7b940";
var _2 = "Divider_dash__a60c3";
var _3 = "Divider_fluid__408e4";
var _4 = "Divider_free__9cc6a";
var _5 = "Divider_ghost__d873f";
var _6 = "Divider_horizontal__9a0f7";
var _7 = "Divider_large__045ad";
var _8 = "Divider_medium__002ef";
var _9 = "Divider_mini__dad18";
var _a = "Divider_vertical__73f54";
var _b = "Divider_xmini__42842";
export { _1 as "dark", _2 as "dash", _3 as "fluid", _4 as "free", _5 as "ghost", _6 as "horizontal", _7 as "large", _8 as "medium", _9 as "mini", _a as "vertical", _b as "xmini" }
